import { CREATE_QUIZ_QUESTION, RESET_QUIZ_CREATION, CREATE_QUIZ_ERROR_REMOVE, CREATE_QUIZ_ERROR_SET } from "../actions/actionTypes";

const initialState = {
  quiz: [],
  error: null,
}

const createReducer = (state = initialState, { type, item, error }) => {
  switch (type) {
    case CREATE_QUIZ_QUESTION:
      return { ...state, quiz: [...state.quiz, item] }
    case RESET_QUIZ_CREATION:
      return { ...state, quiz: [] }
    case CREATE_QUIZ_ERROR_SET:
      return { ...state, error }
    case CREATE_QUIZ_ERROR_REMOVE:
      return { ...state, error: false }
    default:
      return state
  }
}

export default createReducer